import { defineMessages } from 'react-intl-next';

const _default_1: {
    expandButton: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    collapseButton: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
    expandButton: {
        id: 'expandableItem.expandButton',
        defaultMessage: 'Expand',
        description: 'Accessible label for a button on an expandable card. When clicked, this button expands the card to show additional details or content that is currently hidden.',
    },
    collapseButton: {
        id: 'expandableItem.collapseButton',
        defaultMessage: 'Collapse',
        description: 'Accessible label for a button on an expanded card. When clicked, this button collapses the card to hide the additional details or content.',
    },
});
export default _default_1;
